<input #fileInput type="file" name="myfile" (change)="uploadFile($event)" class="file-create" placeholder="Seleccione el archivo">
<div>
    <span class="percent white" *ngIf="uploadPercent | async as pct"  [style.left.%]="(pct | number)"> {{ pct | number:'1.0-0' }}%</span>
    <div class="progress-bar">
        <mat-progress-bar class="progress-bar" mode="determinate" *ngIf="uploadPercent | async as pct" value="{{pct | number:'1.0-0'}}"></mat-progress-bar>
    </div>
</div>